import { InAppContentDefinition } from 'modules/graphql/types';
import { useEditableFieldsContext } from '../../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../../constants';
import { FontFormField } from './shared/FontFormField';

export const RokuButtonFont = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { ottPayload } = (liveTemplate?.mediumData || {}) as InAppContentDefinition;

  const hasButtons = !!(ottPayload?.buttons?.length && ottPayload.buttons.length > 0);

  return (
    <FontFormField
      field="dialogButtonFont"
      value={ottPayload?.dialogButtonFont}
      condition={hasButtons}
      label={SETTINGS_DISPLAY_CONTENT.roku.fonts.buttonLabel}
      data-test="form-field-roku-button-font"
    />
  );
};
